export default __webpack_public_path__ + "static/tecalis-share-c31d9e05373d5d155556f0a6fb2e1f06.jpg";